/**
 * 体验用户 / 未开通词书访问限制
 * 未开通仅允许体验 TRIAL_WORD_LIMIT 个单词
 */
import { getNickName, isTrialUserFlag } from '@/utils/auth'

export const TRIAL_WORD_LIMIT = 5

/** 公共临时体验账号 userId（与后端 TrialBookAccess.TRIAL_USER_ID 一致） */
export const TRIAL_USER_ID = 204

/** 体验账户不允许修改资料时的提示 */
export const TRIAL_PROFILE_LOCKED_TIP = '体验账户不允许修改资料、头像或密码'

/** 体验账户昵称 / 用户名（临时体验登录） */
const TRIAL_NICK_NAMES = ['体验账户']

export function isTrialAccount (userId) {
  if (userId != null && Number(userId) === TRIAL_USER_ID) return true
  if (isTrialUserFlag()) return true
  const name = (getNickName() || '').trim()
  return TRIAL_NICK_NAMES.includes(name)
}

/**
 * 是否处于单词体验限制（未开通该书）
 * isWordPower: 0/ '0' 表示受限
 */
export function isWordTrialLimited (isWordPower) {
  return isWordPower === 0 || isWordPower === '0'
}

/**
 * 体验用户是否还可进入第 index（0-based）个单词
 */
export function canAccessWordIndex (isWordPower, index) {
  if (!isWordTrialLimited(isWordPower)) return true
  return index < TRIAL_WORD_LIMIT
}

export function trialWordLimitToast () {
  return `未开通该书仅可体验前${TRIAL_WORD_LIMIT}个单词，请兑换激活码后学习全部内容`
}

/**
 * 从单元列表推断是否已开通（全部 isWordPower 不为 0 则视为开通）
 */
export function resolveBookWordPower (unitList) {
  if (!Array.isArray(unitList) || unitList.length === 0) return 0
  const locked = unitList.some(u => u.isWordPower === 0 || u.isWordPower === '0')
  return locked ? 0 : 1
}



// WEBPACK FOOTER //
// ./src/utils/trialAccess.js